import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { string, func, bool, array, number, shape, arrayOf } from "prop-types";

import { Button } from "../../../common";

import { isEmpty } from "../../../helpers";

import { ContactPostcode, AddressSelectList } from "..";

import * as style from "./styles.module.scss";
import OnboardImage from "../../OnboardImage";
import ManualAddress from "../Contacts/ManualAddressForm/index";

const BasicInfoAddress = (props) => {
  const {
    firstName,
    postcode,
    postcodeError,
    onChange,
    onBranchChange,
    handleSubmit,
    showManualAddress,
    hideManualAddress,
    shouldShowAddresses,
    matchedAddressList,
    getMatchedAddress,
    isFindingAddress,
    isManualAddress,
    canFindAddress,
    onAddressSelect,
    selectedAddressIndex,
    addressLine1,
    addressLine2,
    addressLine3,
    town,
    country,
    county,
  } = props;

  const manualAddressFormInputs = {
    addressLine1,
    addressLine2,
    addressLine3,
    town,
    country,
    county,
  };
  const [isFormTouched, setFormTouched] = useState(false);
  (() =>
    !isFormTouched &&
    Object.values(manualAddressFormInputs).filter(
      (_formElem) => !!_formElem === true
    ).length > 1 &&
    setFormTouched(true))();

  const handleChangeToShowNextStep = (field, e) => {
    onChange(field, e);
    setFormTouched(true);
  };

  const manualAddressSelectedButNoFilled =
    addressLine1.length <= 0 ||
    town.length <= 0 ||
    county.length <= 0 ||
    postcode.length <= 0;

  const fullAddressProvided =
    addressLine1.length > 0 &&
    town.length > 0 &&
    county.length > 0 &&
    postcode.length > 0;

  const disableNextWhenNoAddress = () => {
    if (selectedAddressIndex === -1) {
      if (manualAddressSelectedButNoFilled) {
        return true;
      }
      return false;
    }
    return false;
  };

  const isMatchedAddressesNotNil = matchedAddressList !== undefined;
  const hasMatchedAddresses =
    isMatchedAddressesNotNil && matchedAddressList.length > 0;

  const [disableNextFromManual, setDisableNextFromManual] = useState(false);

  return (
    <Fragment>
      <div className="row h-100">
        {/* Render contact and postcode inputs with manuall address button */}
        <OnboardImage
          title={`Thanks ${firstName}`}
          subtitle="Where are you based?"
          desktopDescription="Letting us know your address will help you find the right consultant and relevant roles."
          mobileDescription="Letting us know your address will help you find the right consultant and relevant roles."
          imagePath="/images/my_location.svg"
          className={style.location__imageBackground}
          imageClassName={style.location__image}
        />

        <div
          className={`col-sm-12 col-lg-6 mt-2 ${style.location__postcodeSearch}`}
        >
          <div className="row">
            <div className="col-12">
              <div>
                <ContactPostcode
                  memberPostcode={postcode}
                  handleChange={onChange}
                  canFindAddress={canFindAddress}
                  getMatchedAddress={getMatchedAddress}
                />
                {postcodeError && (
                  <div style={{ color: "red", fontSize: "0.9rem" }}>
                    Postcode entered is not recognised, please try again
                  </div>
                )}
              </div>

              {shouldShowAddresses && hasMatchedAddresses ? (
                <Fragment>
                  <div className="mt-1">
                    <p>Please select your address from the list below:</p>
                  </div>
                  <div className={style.location__addressListContainer}>
                    <AddressSelectList
                      onAddressSelect={onAddressSelect}
                      selectedIndex={selectedAddressIndex}
                      addresses={matchedAddressList}
                    />
                  </div>
                </Fragment>
              ) : null}

              {/* If no matched addresses - render suggest message */}
              {isFindingAddress &&
              isMatchedAddressesNotNil &&
              matchedAddressList.length === 0 ? (
                <div className="text-center my-1">
                  <p>
                    Postcode not found. Please change your postcode or enter
                    your address manually.
                  </p>
                </div>
              ) : null}

              <div className="my-1">
                <ManualAddress
                  addressLine1={addressLine1}
                  addressLine2={addressLine2}
                  addressLine3={addressLine3}
                  town={town}
                  county={county}
                  postcode={postcode}
                  country={country}
                  setDisableNextFromManual={setDisableNextFromManual}
                  handleChange={onChange}
                  handleChangeToShowNextStep={handleChangeToShowNextStep}
                />
              </div>
            </div>
          </div>

          <div className={`mt-lg-auto my-2 mb-lg-0 ${style.location__actions}`}>
            <Link
              to={"/onboard/name"}
              className="btn-plain d-block text-info text-center"
            >
              <button className="btn btn-outline-info text-dark mr-1">
                Back
              </button>
            </Link>

            <Button
              classes="btn btn-primary btn-block"
              disabled={!fullAddressProvided}
              onClick={handleSubmit}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

BasicInfoAddress.propTypes = {
  firstName: string.isRequired,
  postcode: string.isRequired,
  postcodeError: bool.isRequired,
  addressLine1: string.isRequired,
  addressLine2: string.isRequired,
  addressLine3: string.isRequired,
  county: string.isRequired,
  town: string.isRequired,
  country: string.isRequired,
  hasTelephoneChanged: bool.isRequired,
  onChange: func.isRequired,
  onBranchChange: func.isRequired,
  handleSubmit: func.isRequired,
  isFindingAddress: bool.isRequired,
  isManualAddress: bool.isRequired,
  showManualAddress: func.isRequired,
  hideManualAddress: func.isRequired,
  shouldShowAddresses: bool.isRequired,
  matchedAddressList: array,
  selectedAddressIndex: number,
  description: string.isRequired,
  loading: bool.isRequired,
  getMatchedAddress: func.isRequired,
  canFindAddress: bool.isRequired,
  onAddressSelect: func.isRequired,
  route: string.isRequired,
};

export default BasicInfoAddress;
